import { Outlet, useRouterState } from '@tanstack/react-router'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { useLocale } from 'react-intlayer'
import { localeAtom } from '@/atoms/input.atom'
import { SiteView } from './site-view'
import { useTheme } from './theme-provider'

export function SiteLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname }).replace(/\/$/, '') || '/'
  const { locale, setLocale } = useLocale()
  const { theme, setTheme } = useTheme()
  const setProductLocale = useSetAtom(localeAtom)
  const appearance =
    theme === 'system' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : theme
  const language = locale === 'en' ? 'en' : 'ja'
  useEffect(() => {
    setProductLocale(language)
    document.documentElement.lang = language
  }, [language, setProductLocale])
  return (
    <SiteView
      page={pathname === '/' ? 'home' : pathname === '/product' ? 'projects' : 'content'}
      locale={language}
      theme={appearance}
      onLocaleChange={setLocale}
      onThemeChange={setTheme}
    >
      <Outlet />
    </SiteView>
  )
}
